import { useTheme } from '@chakra-ui/react';
import { faChevronLeft } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import Text from '~/common/componentMapper/Text';
import Box from '~/common/components/Box';
import Button from '~/common/components/Buttons/Button';
import lang from '~/pages/IncomeCalculator/language.json';

type BackButtonProps = {
  onClose: () => void;
};

export default function BackButton({ onClose }: Readonly<BackButtonProps>) {
  const { colors } = useTheme();
  return (
    <Box pb={4}>
      <Button
        aria-label="back"
        variant="link"
        colorScheme="black"
        onClick={onClose}
        leftIcon={
          <FontAwesomeIcon
            title="Back Arrow"
            color={colors?.blue[500]}
            icon={faChevronLeft}
          />
        }
      >
        <Text fontSize="md" color="blue.500">
          {lang.CALC_HISTORY}
        </Text>
      </Button>
    </Box>
  );
}
